import { createEntityAdapter } from '@reduxjs/toolkit';
import { IJCState } from '~/types/models/jcState';
import { IJCStatus } from '~/types/models/jcStatus';
import { IReportType } from '~/types/models/reportType';

export const JCStatusesAdapter = createEntityAdapter<IJCStatus>({
  selectId: (status) => status.value,
});

export const JCStatesAdapter = createEntityAdapter<IJCState>({
  selectId: (state) => state.value,
});

export const ReportTypesAdapter = createEntityAdapter<IReportType>({
  selectId: (reportType) => reportType._id,
});
